import { useState, useEffect } from "react";
import intl from "react-intl-universal";
import useDataApi from "../../../hooks/useDataApi";
import { fnGetUsersAndTeams } from "../../../services/auth";
import Select from "../../atoms/Select"
export default function RcmpSelectUsersAndTeams(props) {
  const {
    placeholder,
    bIsDraggable,
    bIsDisabled,
    ...oRest
  } = props;

  const [aOptions, fnSetAOptions] = useState([]);
  const [oGetEntitiesRes, fnGetEntitiesReq] = useDataApi(fnGetUsersAndTeams);

  useEffect(() => {
    if (oGetEntitiesRes.loading) return;

    (async () => {
      await fnGetEntitiesReq();
    })();
  }, []);

  useEffect(() => {
    if (oGetEntitiesRes.loading || !oGetEntitiesRes.done) return;

    const oMappedOptions = oGetEntitiesRes.data.reduce((aAcc, oEntity) => {
      const cSection = oEntity.type;
      const aOption = {
        label: oEntity.user_cname,
        nTeamId: oEntity?.team_nid,
        nUserId: oEntity?.user_nid,
        value: oEntity.user_nid ? `U${oEntity.user_nid}` : `T${oEntity.team_nid}`,
      };

      if (!aAcc[cSection]) {
        aAcc[cSection] = { section: intl.get(cSection), options: [aOption] };
      } else {
        aAcc[cSection].options.push(aOption);
      }

      return aAcc;
    }, {});

    const aMappedOptions = Object.values(oMappedOptions);

    fnSetAOptions(aMappedOptions);
  }, [oGetEntitiesRes]);

  const cPlaceHolder = intl.get("select_users_and_teams") || placeholder;

  return (
    <Select
      bIsDraggable={bIsDraggable}
      placeholder={cPlaceHolder}
      options={aOptions}
      multiSelect
      value=""
      bIsDisabled={bIsDisabled}
      {...oRest}
    />
  );
}
